import React from 'react'
import {useHistory} from "react-router"
import {useTranslation} from "react-i18next"

import {IonButton, IonButtons, IonIcon, IonItem, IonItemOptions, IonLabel} from "@ionic/react"
import {
    keyOutline, keySharp,
    lockClosedOutline, lockClosedSharp,
    shieldCheckmarkOutline, shieldCheckmarkSharp,
    timeOutline, timeSharp
} from "ionicons/icons"

import IconLockingSystemZone from "../common/Icons/LockingSystemZone";
import {LockingSystemZone as ItemType} from "../../types/LockingSystemZone"

import {useLockingSystems} from "../../contexts/LockingSystemContext";
import NumberFormat        from "../common/Text/NumberFormat";

interface itemProps {
    item: ItemType;
}

const ListItem: React.FC<itemProps> = ({ item}) => {
    const keysCount: number  = item.counts?.keys  || 0
        , locksCount: number = item.counts?.locks || 0
        , lockingSystemPermissionCount: number = item.counts?.lockingSystemPermissions || 0
        , timeLimitCount: number = item.counts?.timeLimits || 0
        , minButtonWidth: string = '95px'

    const {hasFeature: hasLockingSystemFeature} = useLockingSystems()
    const history = useHistory()
    const { t } = useTranslation()

    const goToSegment = (ev: any, itemId: number, segment: string) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/locking-system-zones/' + itemId + '/' + segment)
    }

    const goToTimeLimits = (ev: any, timeLimitCount: number) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (timeLimitCount) {
            history.push('/time-limits')
        }
    }

    return (
        <>
            <IonItem button routerLink={"/locking-system-zones/" + item.id + "/view"} slot="start" detail={true}>
                <IconLockingSystemZone slot="start" />
                <IonLabel>
                    <h2>{item.name}</h2>
                    <p>{item.description || '(' + t('common.no_description') + ')'}</p>
                </IonLabel>
                <IonButtons className="ion-hide-sm-down" slot="end">
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <IonButton color={keysCount ? "medium" : "light"} fill="clear"
                                   onClick={ (ev) => goToSegment(ev, item.id, 'keys') }
                                   shape="round" size="large" style={{ 'fontSize': '1rem' }}>
                            <IonIcon slot="start" ios={keyOutline} md={keySharp} />
                            <NumberFormat number={keysCount} />
                        </IonButton>
                    </span>
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <IonButton color={locksCount ? "medium" : "light"} fill="clear"
                                   onClick={ (ev) => goToSegment(ev, item.id, 'locks') }
                                   shape="round" size="large" style={{ 'fontSize': '1rem' }}>
                            <IonIcon slot="start" ios={lockClosedOutline} md={lockClosedSharp} />
                            <NumberFormat number={locksCount} />
                        </IonButton>
                    </span>
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <IonButton color={lockingSystemPermissionCount ? "medium" : "light"} fill="clear"
                                   onClick={(ev) => goToSegment(ev, item.id, 'locking-system-permissions')}
                                   shape="round" size="large" style={{ 'fontSize': '1rem' }}>
                            <IonIcon slot="start" ios={shieldCheckmarkOutline} md={shieldCheckmarkSharp} />
                            <NumberFormat number={lockingSystemPermissionCount} />
                        </IonButton>
                    </span>
                    {hasLockingSystemFeature('HAS_TIME_LIMITS') === true &&
                    <span style={{ 'minWidth': minButtonWidth }}>
                        <IonButton color={timeLimitCount ? "medium" : "light"} fill="clear"
                                   onClick={(ev) => goToTimeLimits(ev, timeLimitCount)}
                                   shape="round" size="large" style={{ 'fontSize': '1rem' }}>
                            <IonIcon slot="start" ios={timeOutline} md={timeSharp} />
                            {timeLimitCount ? timeLimitCount : '-'}
                        </IonButton>
                    </span>
                    }
                </IonButtons>
            </IonItem>
            <IonItemOptions slot="end">
                {/*<ListItemOptionDelete item={item} />*/}
            </IonItemOptions>
        </>
    )
}

export default ListItem